var _g, _g2, _g3, _g4, _g5, _g6, _g7, _g8, _g9, _g10, _g11, _g12, _g13, _g14, _g15;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgGermanIcon(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Capa_1",
    xmlns: "http://www.w3.org/2000/svg",
    xlmnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 473.68 473.68",
    style: {
      enableBackground: "new 0 0 473.68 473.68"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("circle", {
    style: {
      fill: "#FFFFFF"
    },
    cx: 236.85,
    cy: 236.85,
    r: 236.83
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#D32027"
    },
    d: "M460.14,157.874H314.218c6.335,50.593,6.376,106.339,0.12,156.995h146.116 c8.526-24.438,13.219-50.682,13.219-78.026C473.677,209.139,468.875,182.573,460.14,157.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#0B0B0B"
    },
    d: "M314.218,157.874H460.14c-0.026-0.075-0.049-0.138-0.075-0.206 C429.752,72.2,351.785,9.319,258.105,0.972C294.357,20.844,304.944,83.804,314.218,157.874z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F3C515"
    },
    d: "M258.109,472.697c93.848-8.362,171.927-71.46,202.12-157.156c0.079-0.228,0.146-0.452,0.228-0.673 h-146.12C305.142,389.338,294.51,452.743,258.109,472.697z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#DB2727"
    },
    d: "M0,236.842c0,27.348,4.693,53.588,13.219,78.026h313.313c6.256-50.66,6.215-106.402-0.12-156.995 H13.534C4.798,182.573,0,209.139,0,236.842z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#151515"
    },
    d: "M13.605,157.668c-0.026,0.067-0.049,0.131-0.075,0.206h312.883 c-9.274-74.07-32.056-137.029-68.303-156.901C251.097,0.352,244.007,0,236.835,0C133.806,0,46.184,65.802,13.605,157.668z"
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#F8D12E"
    },
    d: "M326.532,314.868H13.219c0.079,0.221,0.15,0.445,0.228,0.673 c32.452,92.102,120.19,158.135,223.387,158.135c7.173,0,14.263-0.352,21.274-0.98C294.51,452.743,317.336,389.338,326.532,314.868z"
  }), _g || (_g = /*#__PURE__*/React.createElement("g", null)), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", null)), _g3 || (_g3 = /*#__PURE__*/React.createElement("g", null)), _g4 || (_g4 = /*#__PURE__*/React.createElement("g", null)), _g5 || (_g5 = /*#__PURE__*/React.createElement("g", null)), _g6 || (_g6 = /*#__PURE__*/React.createElement("g", null)), _g7 || (_g7 = /*#__PURE__*/React.createElement("g", null)), _g8 || (_g8 = /*#__PURE__*/React.createElement("g", null)), _g9 || (_g9 = /*#__PURE__*/React.createElement("g", null)), _g10 || (_g10 = /*#__PURE__*/React.createElement("g", null)), _g11 || (_g11 = /*#__PURE__*/React.createElement("g", null)), _g12 || (_g12 = /*#__PURE__*/React.createElement("g", null)), _g13 || (_g13 = /*#__PURE__*/React.createElement("g", null)), _g14 || (_g14 = /*#__PURE__*/React.createElement("g", null)), _g15 || (_g15 = /*#__PURE__*/React.createElement("g", null)));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgGermanIcon);
export default __webpack_public_path__ + "static/media/german_icon.3eb6c97190c5621dde94c614c524ecd2.svg";
export { ForwardRef as ReactComponent };